<template>
  <v-container
    fluid
    class="d-flex justify-center align-start"
    style="min-height: 100vh; border-radius: 0; overflow: auto"
    :class="BeyondSelected ? 'completedapp' : ''"
  >
    <v-row class="d-flex justify-center">
      <v-col cols="12" sm="6" md="4" lg="10">
        <v-card rounded="0">
          <v-toolbar flat dense color="#005F95">
            <div>
              <!-- Small to Large Screens -->
              <h1
                class="Limit-Toolbar"
                :style="{
                  fontSize: isSmall ? '11px' : isMedium ? '16px' : '20px',
                }"
              >
                DINERS CLUB {{ product }} ONLINE APPLICATION
              </h1>
            </div>
          </v-toolbar>

          <v-container
            fluid
            style="border: 1px solid #ccc; border-radius: 0; padding: 16px"
          >
            <v-container fluid style="border-radius: 0; padding: 16px">
              <v-row>
                <v-col cols="12">
                  <h1 class="Credit-Limit-Approve" style="text-align: left">
                    {{ product }} APPLICATION SUBMITTED
                  </h1>
                </v-col>
              </v-row>

              <v-row>
                <v-col cols="12" sm="13">
                  <p style="text-align: left">
                    Thank you for applying for a Diners Club Card. An agent will
                    be in touch with you soon. If you have any questions or
                    would like more information, you are welcome to contact us
                    at 0860-DINERS (346377) and qoute your reference number:
                    <b>{{ refNumber }}</b
                    >.
                  </p>
                </v-col>
              </v-row>

              <v-row>
                <v-col cols="12" sm="13">
                  <p style="text-align: left">
                    You may send the Supporting Documents to:
                    <a href="supporting.docs@dinersclub.co.za" target="_top"
                      >supporting.docs@dinersclub.co.za</a
                    >
                    Please quote the above reference number when sending your
                    documents.
                  </p>
                </v-col>
              </v-row>

              <v-row justify="center">
                <v-col cols="12" class="text-center">
                 <v-btn
                  style="border-radius: 0; width: 220px; height: 30px"
                  @click="completedApp"
                  :loading="isLoading"
                  :disabled="isLoading"
                  color="#005F95"
                  class="white--text"
                >
                  FINISH
                </v-btn>
                </v-col>
                <p v-if="isLoading" style="margin-top: 10px; color:#041e42;">
                  {{ loadingMessage }} ({{ downloadProgress }}/{{ totalDocs }})
                </p>
              </v-row>
            </v-container>
          </v-container>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script setup>
/* eslint-disable */
import { useDisplay } from "vuetify/lib/framework.mjs";
import { ref, onBeforeMount, computed, onMounted } from "vue";
import { useRouter } from "vue-router";
import axios from "axios"; // Import axios if not globally available

const IDType = sessionStorage.getItem("IDType");
const { smAndDown, mdAndUp, lgAndUp } = useDisplay();
const isSmall = smAndDown;
const isMedium = computed(() => mdAndUp.value && !lgAndUp.value);
const product = ref("");
const router = useRouter();
const prodtype = ref("");
const refNumber =ref("");
const appStatus = ref("")
const apptype = ref("")
const isLoading = ref(false);
const loadingMessage = ref("");
const downloadProgress = ref(0);
const totalDocs = 3;

const BeyondSelected = ref(false);

// onMounted(() => {
//   if (router.name === 'CompletedApp') {
//     document.body.style.overflow = 'hidden'; // Lock scrolling
//   }
// });

onBeforeMount(() => {
  // Get product type from session storage
  appStatus.value = sessionStorage.getItem("appStatus");
  prodtype.value = sessionStorage.getItem("prodtype");
  apptype.value = sessionStorage.getItem("apptype");



  if (apptype.value === "newapp") {
    refNumber.value = sessionStorage.getItem("refNumber");
  } else if (apptype.value === "continueapp") {
    refNumber.value = sessionStorage.getItem("incompleteRef");
  }


  const productMap = {
    platinum: "CREDIT CARD",
    shariah: "SHARI'AH CARD",
    beyond: "BEYOND CARD",
  };
  product.value = productMap[prodtype.value] || "CREDIT CARD";
  BeyondSelected.value = prodtype.value === "beyond";

});

//%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%---Function to get customer documents to be downlaoded---%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%"

const getSession = (key) => sessionStorage.getItem(key);
const delay = (ms) => new Promise(resolve => setTimeout(resolve, ms));


// ----------------------Latest Working with redirect inside------------------- 
// const completedApp = async () => {
//   isLoading.value = true;
//   loadingMessage.value = "Downloading your documents...";

//   try {
//     if (getSession("IDType") === "Passport") {
//       isLoading.value = false;

//       window.location.assign("https://www.dinersclub.co.za");
//       sessionStorage.clear();
//       return;
//     }

//     // ✅ Wait ONLY for downloads
//     await getCustomerDocuments();

//     // ✅ STOP loading immediately after downloads
//     isLoading.value = false;

//     // ✅ Then do redirect stuff WITHOUT blocking UI
//     setTimeout(() => {
//       window.location.assign("https://www.dinersclub.co.za");
//     }, 2000);

//     setTimeout(() => {
//       sessionStorage.clear();
//     }, 5000);

//   } catch (error) {
//     console.error("Error in completedApp:", error);
//     isLoading.value = false;
//     loadingMessage.value = "";
//   }
// };

const completedApp = async () => {
  isLoading.value = true;
  loadingMessage.value = "Downloading your documents...";
  downloadProgress.value = 0;

  try {
    if (getSession("IDType") === "Passport") {
      window.location.assign("https://www.dinersclub.co.za");
      sessionStorage.clear();
      return;
    }

    await getCustomerDocuments();

    // success flow
    isLoading.value = false;

    setTimeout(() => {
      window.location.assign("https://www.dinersclub.co.za");
    }, 2000);

    setTimeout(() => {
      sessionStorage.clear();
    }, 5000);

  } catch (error) {
    console.error("CompletedApp failed:", error);

    // Stop UI loading
    isLoading.value = false;

    // optional: reset or keep last known progress
    loadingMessage.value = "Failed to download documents. Please try again. Alternatively, copies have been sent to your email.";
  }
};

const downloadDocument = async (url, filename) => {

  const token = getSession("authToken");

  if (!token || !refNumber.value) {
    console.log("User not authorized");
    return;
  }

  try {
    const response = await axios.post(
      url,
      {
        _REFNUMBER: refNumber.value,
        _PAQ_STATUS: "Accepted",
      },
      {
        responseType: "blob",
        headers: {
          Authorization: token,
        },
      }
    );

    const fileBlob = new Blob([response.data]);
    const fileUrl = window.URL.createObjectURL(fileBlob);

    const link = document.createElement("a");
    link.href = fileUrl;
    link.setAttribute("download", filename);
    document.body.appendChild(link);
    link.click();

    // cleanup
    link.remove();
    window.URL.revokeObjectURL(fileUrl);

  } catch (error) {
    console.error(`Error downloading ${filename}:`, error);
  }
};

// ----------------------Latest Working without redirect inside------------------- 
// const getCustomerDocuments = async () => {
//   try {
//     if (getSession("IDType") === "RSA ID") {

//       await delay(15000);
//       await downloadDocument(
//         "/getCustomerMembershipAgreement",
//         `MembershipAgreement-${refNumber.value}.pdf`
//       );

//       await delay(10000);
//       await downloadDocument(
//         "/getCustomerTCnCs",
//         `TermsandConditions-${refNumber.value}.pdf`
//       );

//       await delay(10000);
//       await downloadDocument(
//         "/getCustomerPAQ",
//         `Agreement-${refNumber.value}.pdf`
//       );
//     }

//     // ✅ RETURN when downloads are done
//     return true;

//   } catch (error) {
//     console.error("Error in document flow:", error);
//     throw error;
//   }
// };


const getCustomerDocuments = async () => {
  downloadProgress.value = 0;

  try {
    if (getSession("IDType") === "RSA ID") {

      await delay(15000);
      await downloadDocument(
        "/getCustomerMembershipAgreement",
        `MembershipAgreement-${refNumber.value}.pdf`
      );
      downloadProgress.value = 1;

      await delay(10000);
      await downloadDocument(
        "/getCustomerTCnCs",
        `TermsandConditions-${refNumber.value}.pdf`
      );
      downloadProgress.value = 2;

      await delay(10000);
      await downloadDocument(
        "/getCustomerPAQ",
        `Agreement-${refNumber.value}.pdf`
      );
      downloadProgress.value = 3;
    }

    return true;

  } catch (error) {
    console.error("Download failed:", error);

    // Stop progress cleanly
    throw error; // let parent handle UI state
  }
};
</script>
<style>
.completedapp {
  background: url("../assets/images/Beyondform.jpg") no-repeat center center;
  background-size: cover;
  width: 100%;
  display: flex;
  height: 100vh;
  min-height: 100vh;
  overflow: hidden !important;
}

#border {
  border-top: 3px solid #000;
}

@font-face {
  font-family: "GathamLight";
  src: url("@/assets/fonts/Gotham-Light.woff2") format("woff2"),
    url("@/assets/fonts/Gotham-Light.otf") format("opentype");
  font-display: swap;
}
p {
  text-align: left;
  font-family: "GathamLight";
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #041e42;
}

h1 {
  color: #041e42;
}
</style>
